module.exports = __webpack_public_path__ + "media/images/blue-e6ad19ff93c015efd897443c4b0e321f.png";